import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const CARENOTES_DIRECT_QUERY_KEY = "careNotesDirectQuery";

export const useCareNotesDirectQuery = (patientUserId) => {
  return useQuery({
    queryKey: [CARENOTES_DIRECT_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listCareNotesDirect.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId
  });
};

const listCareNotesDirect = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "carenotesapi",
    path: "/direct/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
